import { render, staticRenderFns } from "./ActionSave.vue?vue&type=template&id=c71f1910&scoped=true&"
import script from "./ActionSave.vue?vue&type=script&lang=js&"
export * from "./ActionSave.vue?vue&type=script&lang=js&"
import style0 from "./ActionSave.vue?vue&type=style&index=0&id=c71f1910&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71f1910",
  null
  
)

export default component.exports